import { withStyles } from '@material-ui/core';

import SortControl from './component';
import styles from './styles';

export default withStyles(styles)(SortControl);
